import { EmailTemplate } from '../components/timeline-types';

// Pre-built email templates
const MODERN_TEMPLATE: EmailTemplate = {
  id: 'modern-template',
  name: 'Simple & Effective',
  description: 'Clean, focused design inspired by top e-commerce brands',
  isDefault: true,
  placeholders: ['{{COMPANY_NAME}}', '{{COMPANY_LOGO}}', '{{HEADER_TITLE}}', '{{HEADER_SUBTITLE}}', '{{WELCOME_MESSAGE}}', '{{PRODUCT_SECTION_TITLE}}', '{{PRODUCTS}}', '{{VOUCHER_SECTION}}', '{{FOOTER_TEXT}}', '{{COPYRIGHT_TEXT}}', '{{POWERED_BY_TEXT}}', '{{POWERED_BY_ARDEALY_TEXT}}', '{{PRIMARY_COLOR}}', '{{SECONDARY_COLOR}}', '{{CTA_BUTTON_TEXT}}'],
  htmlContent: `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>{{HEADER_TITLE}}</title>
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
    </style>
</head>
<body style="margin: 0; padding: 0; background-color: #ffffff; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;">
    <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff;">
        
        <!-- Header with Logo -->
        <div style="background-color: #ffffff; padding: 30px 40px 20px 40px; text-align: center; border-bottom: 1px solid #f0f0f0;">
            {{COMPANY_LOGO}}
        </div>
        
        <!-- Hero Section -->
        <div style="background-color: #ffffff; padding: 40px 40px 30px 40px; text-align: center;">
            <h1 style="font-size: 32px; font-weight: 700; color: #1a1a1a; margin: 0 0 15px 0; line-height: 1.2; letter-spacing: -0.5px;">
                {{HEADER_TITLE}}
            </h1>
            <p style="font-size: 18px; color: #666666; margin: 0 0 30px 0; line-height: 1.4; font-weight: 400;">
                {{HEADER_SUBTITLE}}
            </p>
        </div>
        
        <!-- Welcome Message -->
        <div style="padding: 0 40px 30px 40px;">
            <div style="background-color: #f8f9fa; padding: 25px; border-radius: 8px; border-left: 4px solid {{PRIMARY_COLOR}};">
                <div style="font-size: 16px; line-height: 1.6; color: #333333; white-space: pre-line;">
                    {{WELCOME_MESSAGE}}
                </div>
            </div>
        </div>
        
        <!-- Products Section -->
        <div style="padding: 0 40px 40px 40px;">
            <h2 style="font-size: 24px; font-weight: 600; color: #1a1a1a; text-align: center; margin: 0 0 30px 0; letter-spacing: -0.3px;">
                {{PRODUCT_SECTION_TITLE}}
            </h2>
            {{PRODUCTS}}
        </div>
        
        <!-- Voucher Section -->
        {{VOUCHER_SECTION}}
        
        <!-- Footer -->
        <div style="background-color: #1a1a1a; padding: 40px; text-align: center;">
            <p style="font-size: 14px; color: #cccccc; margin: 0 0 20px 0; line-height: 1.5;">
                {{FOOTER_TEXT}}
            </p>
            <p style="font-size: 12px; color: #888888; margin: 0 0 30px 0;">
                © 2026 {{COMPANY_NAME}}. {{COPYRIGHT_TEXT}}
            </p>
            
            <!-- Powered by Ardealy -->
            <div style="border-top: 1px solid #333333; padding-top: 25px;">
                <p style="font-size: 11px; color: #666666; margin: 0 0 10px 0;">
                    {{POWERED_BY_ARDEALY_TEXT}}
                </p>
                <img src="http://go.ardealy.com/wp-content/uploads/2024/10/cropped-ardealy-black-logo-1.png" alt="Ardealy" style="height: 20px; opacity: 0.6;" />
            </div>
        </div>
    </div>
</body>
</html>
  `
};

const CLASSIC_TEMPLATE: EmailTemplate = {
  id: 'classic-template',
  name: 'Minimal Professional',
  description: 'Ultra-clean design with maximum impact',
  isDefault: false,
  placeholders: ['{{COMPANY_NAME}}', '{{COMPANY_LOGO}}', '{{HEADER_TITLE}}', '{{HEADER_SUBTITLE}}', '{{WELCOME_MESSAGE}}', '{{PRODUCT_SECTION_TITLE}}', '{{PRODUCTS}}', '{{VOUCHER_SECTION}}', '{{FOOTER_TEXT}}', '{{COPYRIGHT_TEXT}}', '{{POWERED_BY_TEXT}}', '{{POWERED_BY_ARDEALY_TEXT}}', '{{PRIMARY_COLOR}}', '{{SECONDARY_COLOR}}', '{{CTA_BUTTON_TEXT}}'],
  htmlContent: `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>{{HEADER_TITLE}}</title>
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
    </style>
</head>
<body style="margin: 0; padding: 0; background-color: #fafafa; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;">
    <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; box-shadow: 0 0 20px rgba(0,0,0,0.05);">
        
        <!-- Header -->
        <div style="background-color: #ffffff; padding: 25px 30px; text-align: center; border-bottom: 1px solid #eeeeee;">
            {{COMPANY_LOGO}}
        </div>
        
        <!-- Main Content -->
        <div style="padding: 50px 30px; text-align: center;">
            <h1 style="font-size: 28px; font-weight: 600; color: #2d3748; margin: 0 0 12px 0; line-height: 1.3;">
                {{HEADER_TITLE}}
            </h1>
            <p style="font-size: 16px; color: #718096; margin: 0 0 40px 0; line-height: 1.5;">
                {{HEADER_SUBTITLE}}
            </p>
            
            <!-- Welcome Message -->
            <div style="text-align: left; margin-bottom: 40px;">
                <div style="font-size: 15px; line-height: 1.7; color: #4a5568; white-space: pre-line;">
                    {{WELCOME_MESSAGE}}
                </div>
            </div>
            
            <!-- Products -->
            <div style="margin-bottom: 40px;">
                <h2 style="font-size: 20px; font-weight: 600; color: #2d3748; margin: 0 0 25px 0;">
                    {{PRODUCT_SECTION_TITLE}}
                </h2>
                {{PRODUCTS}}
            </div>
        </div>
        
        <!-- Voucher Section -->
        {{VOUCHER_SECTION}}
        
        <!-- Footer -->
        <div style="background-color: #f7fafc; padding: 30px; text-align: center; border-top: 1px solid #e2e8f0;">
            <p style="font-size: 13px; color: #718096; margin: 0 0 15px 0;">
                {{FOOTER_TEXT}}
            </p>
            <p style="font-size: 11px; color: #a0aec0; margin: 0 0 20px 0;">
                {{COMPANY_NAME}} • {{COPYRIGHT_TEXT}}
            </p>
            
            <!-- Powered by Ardealy -->
            <div style="border-top: 1px solid #e2e8f0; padding-top: 20px;">
                <p style="font-size: 10px; color: #a0aec0; margin: 0 0 8px 0;">
                    {{POWERED_BY_ARDEALY_TEXT}}
                </p>
                <img src="http://go.ardealy.com/wp-content/uploads/2024/10/cropped-ardealy-black-logo-1.png" alt="Ardealy" style="height: 18px; opacity: 0.5;" />
            </div>
        </div>
    </div>
</body>
</html>
  `
};

export class EmailTemplatesService {
  private static templates: EmailTemplate[] = [MODERN_TEMPLATE, CLASSIC_TEMPLATE];
  private static customTemplates: EmailTemplate[] = [];

  static getAllTemplates(): EmailTemplate[] {
    return [...this.templates, ...this.customTemplates];
  }

  static getDefaultTemplate(): EmailTemplate {
    return this.templates.find(t => t.isDefault) || this.templates[0];
  }

  static getTemplateById(id: string): EmailTemplate | undefined {
    return this.getAllTemplates().find(t => t.id === id);
  }

  static addCustomTemplate(template: Omit<EmailTemplate, 'id' | 'isCustom' | 'createdAt'>): EmailTemplate {
    const newTemplate: EmailTemplate = {
      ...template,
      id: `custom-${Date.now()}`,
      isCustom: true,
      createdAt: new Date().toISOString()
    };
    this.customTemplates.push(newTemplate);
    return newTemplate;
  }

  static deleteCustomTemplate(id: string): boolean {
    const index = this.customTemplates.findIndex(t => t.id === id);
    if (index > -1) {
      this.customTemplates.splice(index, 1);
      return true;
    }
    return false;
  }

  // Product Layout Designs
  static getProductLayouts() {
    return [
      {
        id: 'minimal-list',
        name: 'Minimal List',
        description: 'Simple text-based product list',
        icon: '📝',
        maxProducts: 10
      },
      {
        id: 'grid-cards',
        name: 'Grid Cards',
        description: 'Clean card layout with images and CTA buttons',
        icon: '🔲',
        maxProducts: 6
      },
      {
        id: 'horizontal-list',
        name: 'Horizontal List',
        description: 'Side-by-side product showcase',
        icon: '📋',
        maxProducts: 4
      },
      {
        id: 'featured-hero',
        name: 'Featured Hero',
        description: 'Large hero product with smaller thumbnails',
        icon: '⭐',
        maxProducts: 5
      },
      {
        id: 'compact-tiles',
        name: 'Compact Tiles',
        description: 'Space-efficient tile layout',
        icon: '🔳',
        maxProducts: 8
      },
      {
        id: 'magazine-style',
        name: 'Magazine Style',
        description: 'Editorial layout with varied sizes',
        icon: '📰',
        maxProducts: 6
      }
    ];
  }

  static generateProductHtml(
    products: any[], 
    primaryColor: string = '#667eea', 
    secondaryColor: string = '#764ba2', 
    ctaButtonText: string = 'View Product →',
    layout: string = 'minimal-list'
  ): string {
    if (products.length === 0) {
      return '<p style="text-align: center; color: #999999; font-size: 14px; font-style: italic;">No products selected</p>';
    }

    switch (layout) {
      case 'grid-cards':
        return this.generateGridCardsLayout(products, primaryColor, secondaryColor, ctaButtonText);
      case 'horizontal-list':
        return this.generateHorizontalListLayout(products, primaryColor, secondaryColor, ctaButtonText);
      case 'featured-hero':
        return this.generateFeaturedHeroLayout(products, primaryColor, secondaryColor, ctaButtonText);
      case 'compact-tiles':
        return this.generateCompactTilesLayout(products, primaryColor, secondaryColor, ctaButtonText);
      case 'magazine-style':
        return this.generateMagazineStyleLayout(products, primaryColor, secondaryColor, ctaButtonText);
      case 'minimal-list':
      default:
        return this.generateMinimalListLayout(products, primaryColor, secondaryColor, ctaButtonText);
    }
  }

  private static generateGridCardsLayout(products: any[], primaryColor: string, secondaryColor: string, ctaButtonText: string): string {
    const productCards = products.map(product => `
      <div style="
        display: inline-block; 
        width: calc(50% - 10px); 
        margin: 5px; 
        vertical-align: top;
        background-color: #ffffff; 
        border: 1px solid #f0f0f0;
        border-radius: 12px; 
        overflow: hidden; 
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      ">
        ${product.thumbnailPath ? `
          <img src="${product.thumbnailPath}" alt="${product.productName}" 
               style="width: 100%; height: 180px; object-fit: cover; display: block;">
        ` : `
          <div style="
            width: 100%; 
            height: 180px; 
            background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
            color: white; 
            display: flex; 
            align-items: center; 
            justify-content: center; 
            font-size: 32px; 
            font-weight: 700;
            letter-spacing: -1px;
          ">
            ${product.productName.charAt(0)}
          </div>
        `}
        <div style="padding: 20px; text-align: center;">
          <h3 style="margin: 0 0 6px 0; color: #1a1a1a; font-size: 16px; font-weight: 600; line-height: 1.3;">
            ${product.productName}
          </h3>
          ${product.productBrand ? `
            <p style="margin: 0 0 15px 0; color: #666666; font-size: 13px; font-weight: 400;">
              ${product.productBrand}
            </p>
          ` : '<div style="margin-bottom: 15px;"></div>'}
          <a href="${product.addToCartLink || product.link || '#'}" style="
            display: inline-block;
            background-color: ${primaryColor};
            color: white;
            text-decoration: none;
            padding: 12px 24px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 0.3px;
            transition: all 0.2s ease;
            text-transform: uppercase;
          ">
            ${ctaButtonText}
          </a>
        </div>
      </div>
    `).join('');

    return `
      <div style="text-align: center; line-height: 0;">
        ${productCards}
      </div>
    `;
  }

  private static generateHorizontalListLayout(products: any[], primaryColor: string, secondaryColor: string, ctaButtonText: string): string {
    const productItems = products.map(product => `
      <div style="
        display: inline-block;
        width: calc(25% - 15px);
        margin: 0 7.5px 20px 7.5px;
        vertical-align: top;
        text-align: center;
        background-color: #ffffff;
        border-radius: 8px;
        padding: 15px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.08);
      ">
        ${product.thumbnailPath ? `
          <img src="${product.thumbnailPath}" alt="${product.productName}" 
               style="width: 80px; height: 80px; object-fit: cover; border-radius: 50%; margin-bottom: 12px;">
        ` : `
          <div style="
            width: 80px; 
            height: 80px; 
            background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
            color: white; 
            border-radius: 50%;
            display: flex; 
            align-items: center; 
            justify-content: center; 
            font-size: 24px; 
            font-weight: 700;
            margin: 0 auto 12px auto;
          ">
            ${product.productName.charAt(0)}
          </div>
        `}
        <h4 style="margin: 0 0 8px 0; color: #1a1a1a; font-size: 14px; font-weight: 600; line-height: 1.2;">
          ${product.productName}
        </h4>
        <a href="${product.addToCartLink || product.link || '#'}" style="
          display: inline-block;
          background-color: ${primaryColor};
          color: white;
          text-decoration: none;
          padding: 8px 16px; 
          border-radius: 4px; 
          font-size: 11px; 
          font-weight: 600;
          text-transform: uppercase;
        ">
          ${ctaButtonText}
        </a>
      </div>
    `).join('');

    return `
      <div style="text-align: center; line-height: 0;">
        ${productItems}
      </div>
    `;
  }

  private static generateFeaturedHeroLayout(products: any[], primaryColor: string, secondaryColor: string, ctaButtonText: string): string {
    if (products.length === 0) return '';
    
    const heroProduct = products[0];
    const otherProducts = products.slice(1, 5);

    const heroHtml = `
      <div style="
        background-color: #ffffff;
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: 20px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      ">
        <div style="display: table; width: 100%;">
          <div style="display: table-cell; width: 50%; vertical-align: middle;">
            ${heroProduct.thumbnailPath ? `
              <img src="${heroProduct.thumbnailPath}" alt="${heroProduct.productName}" 
                   style="width: 100%; height: 200px; object-fit: cover;">
            ` : `
              <div style="
                width: 100%; 
                height: 200px; 
                background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
                color: white; 
                display: flex; 
                align-items: center; 
                justify-content: center; 
                font-size: 48px; 
                font-weight: 700;
              ">
                ${heroProduct.productName.charAt(0)}
              </div>
            `}
          </div>
          <div style="display: table-cell; width: 50%; vertical-align: middle; padding: 30px;">
            <h2 style="margin: 0 0 12px 0; color: #1a1a1a; font-size: 24px; font-weight: 700; line-height: 1.2;">
              ${heroProduct.productName}
            </h2>
            ${heroProduct.productBrand ? `
              <p style="margin: 0 0 20px 0; color: #666666; font-size: 16px;">
                ${heroProduct.productBrand}
              </p>
            ` : ''}
            <a href="${heroProduct.addToCartLink || heroProduct.link || '#'}" style="
              display: inline-block;
              background-color: ${primaryColor};
              color: white;
              text-decoration: none;
              padding: 16px 32px;
              border-radius: 8px;
              font-size: 16px;
              font-weight: 600;
              text-transform: uppercase;
            ">
              ${ctaButtonText}
            </a>
          </div>
        </div>
      </div>
    `;

    const thumbnailsHtml = otherProducts.length > 0 ? `
      <div style="text-align: center;">
        ${otherProducts.map(product => `
          <div style="
            display: inline-block;
            width: calc(25% - 10px);
            margin: 5px;
            vertical-align: top;
            background-color: #ffffff;
            border-radius: 8px;
            padding: 15px;
            text-align: center;
            box-shadow: 0 1px 4px rgba(0,0,0,0.06);
          ">
            ${product.thumbnailPath ? `
              <img src="${product.thumbnailPath}" alt="${product.productName}" 
                   style="width: 60px; height: 60px; object-fit: cover; border-radius: 6px; margin-bottom: 8px;">
            ` : `
              <div style="
                width: 60px; 
                height: 60px; 
                background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
                color: white; 
                border-radius: 6px;
                display: flex; 
                align-items: center; 
                justify-content: center; 
                font-size: 18px; 
                font-weight: 700;
                margin: 0 auto 8px auto;
              ">
                ${product.productName.charAt(0)}
              </div>
            `}
            <h4 style="margin: 0 0 8px 0; color: #1a1a1a; font-size: 12px; font-weight: 600; line-height: 1.2;">
              ${product.productName}
            </h4>
            <a href="${product.addToCartLink || product.link || '#'}" style="
              display: inline-block;
              background-color: ${primaryColor}; 
              color: white; 
              text-decoration: none; 
              padding: 6px 12px; 
              border-radius: 4px; 
              font-size: 10px; 
              font-weight: 600;
              text-transform: uppercase;
            ">
              View
            </a>
          </div>
        `).join('')}
      </div>
    ` : '';

    return heroHtml + thumbnailsHtml;
  }

  private static generateCompactTilesLayout(products: any[], primaryColor: string, secondaryColor: string, ctaButtonText: string): string {
    const productTiles = products.map(product => `
      <div style="
        display: inline-block;
        width: calc(33.33% - 10px);
        margin: 5px;
        vertical-align: top;
        background-color: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 8px;
        overflow: hidden;
        text-align: center;
        box-shadow: 0 1px 3px rgba(0,0,0,0.05);
      ">
        ${product.thumbnailPath ? `
          <img src="${product.thumbnailPath}" alt="${product.productName}" 
               style="width: 100%; height: 120px; object-fit: cover;">
        ` : `
          <div style="
            width: 100%; 
            height: 120px; 
            background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
            color: white; 
            display: flex; 
            align-items: center; 
            justify-content: center; 
            font-size: 24px; 
            font-weight: 700;
          ">
            ${product.productName.charAt(0)}
          </div>
        `}
        <div style="padding: 12px;">
          <h4 style="margin: 0 0 8px 0; color: #1a1a1a; font-size: 13px; font-weight: 600; line-height: 1.2;">
            ${product.productName}
          </h4>
          <a href="${product.addToCartLink || product.link || '#'}" style="
            display: inline-block;
            background-color: ${primaryColor}; 
            color: white; 
            text-decoration: none; 
            padding: 8px 16px; 
            border-radius: 4px; 
            font-size: 11px; 
            font-weight: 600;
            text-transform: uppercase;
          ">
            View
          </a>
        </div>
      </div>
    `).join('');

    return `
      <div style="text-align: center; line-height: 0;">
        ${productTiles}
      </div>
    `;
  }

  private static generateMagazineStyleLayout(products: any[], primaryColor: string, secondaryColor: string, ctaButtonText: string): string {
    if (products.length === 0) return '';

    const mainProduct = products[0];
    const sideProducts = products.slice(1, 3);
    const bottomProducts = products.slice(3, 6);

    const mainSection = `
      <div style="margin-bottom: 20px;">
        <div style="display: table; width: 100%; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">
          <div style="display: table-cell; width: 60%; vertical-align: top;">
            ${mainProduct.thumbnailPath ? `
              <img src="${mainProduct.thumbnailPath}" alt="${mainProduct.productName}" 
                   style="width: 100%; height: 200px; object-fit: cover;">
            ` : `
              <div style="
                width: 100%; 
                height: 200px; 
                background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
                color: white; 
                display: flex; 
                align-items: center; 
                justify-content: center; 
                font-size: 36px; 
                font-weight: 700;
              ">
                ${mainProduct.productName.charAt(0)}
              </div>
            `}
          </div>
          <div style="display: table-cell; width: 40%; vertical-align: middle; padding: 25px;">
            <h3 style="margin: 0 0 10px 0; color: #1a1a1a; font-size: 20px; font-weight: 700; line-height: 1.2;">
              ${mainProduct.productName}
            </h3>
            ${mainProduct.productBrand ? `
              <p style="margin: 0 0 15px 0; color: #666666; font-size: 14px;">
                ${mainProduct.productBrand}
              </p>
            ` : ''}
            <a href="${mainProduct.addToCartLink || mainProduct.link || '#'}" style="
              display: inline-block;
              background-color: ${primaryColor};
              color: white;
              text-decoration: none;
              padding: 12px 24px;
              border-radius: 6px;
              font-size: 14px;
              font-weight: 600;
              text-transform: uppercase;
            ">
              ${ctaButtonText}
            </a>
          </div>
        </div>
      </div>
    `;

    const sideSection = sideProducts.length > 0 ? `
      <div style="margin-bottom: 20px;">
        ${sideProducts.map(product => `
          <div style="
            display: inline-block;
            width: calc(50% - 10px);
            margin: 5px;
            vertical-align: top;
            background-color: #ffffff;
            border-radius: 8px;
            padding: 20px;
            text-align: center;
            box-shadow: 0 1px 4px rgba(0,0,0,0.06);
          ">
            ${product.thumbnailPath ? `
              <img src="${product.thumbnailPath}" alt="${product.productName}" 
                   style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px; margin-bottom: 12px;">
            ` : `
              <div style="
                width: 80px; 
                height: 80px; 
                background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
                color: white; 
                border-radius: 8px;
                display: flex; 
                align-items: center; 
                justify-content: center; 
                font-size: 24px; 
                font-weight: 700;
                margin: 0 auto 12px auto;
              ">
                ${product.productName.charAt(0)}
              </div>
            `}
            <h4 style="margin: 0 0 10px 0; color: #1a1a1a; font-size: 14px; font-weight: 600; line-height: 1.2;">
              ${product.productName}
            </h4>
            <a href="${product.addToCartLink || product.link || '#'}" style="
              display: inline-block;
              background-color: ${primaryColor}; 
              color: white; 
              text-decoration: none; 
              padding: 8px 16px; 
              border-radius: 4px; 
              font-size: 12px; 
              font-weight: 600;
              text-transform: uppercase;
            ">
              View
            </a>
          </div>
        `).join('')}
      </div>
    ` : '';

    const bottomSection = bottomProducts.length > 0 ? `
      <div style="text-align: center;">
        ${bottomProducts.map(product => `
          <div style="
            display: inline-block;
            width: calc(33.33% - 10px);
            margin: 5px;
            vertical-align: top;
            background-color: #ffffff;
            border-radius: 6px;
            padding: 15px;
            text-align: center;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
          ">
            ${product.thumbnailPath ? `
              <img src="${product.thumbnailPath}" alt="${product.productName}" 
                   style="width: 60px; height: 60px; object-fit: cover; border-radius: 6px; margin-bottom: 8px;">
            ` : `
              <div style="
                width: 60px; 
                height: 60px; 
                background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
                color: white; 
                border-radius: 6px;
                display: flex; 
                align-items: center; 
                justify-content: center; 
                font-size: 18px; 
                font-weight: 700;
                margin: 0 auto 8px auto;
              ">
                ${product.productName.charAt(0)}
              </div>
            `}
            <h5 style="margin: 0 0 6px 0; color: #1a1a1a; font-size: 12px; font-weight: 600; line-height: 1.2;">
              ${product.productName}
            </h5>
            <a href="${product.addToCartLink || product.link || '#'}" style="
              display: inline-block;
              background-color: ${primaryColor}; 
              color: white; 
              text-decoration: none; 
              padding: 6px 12px; 
              border-radius: 3px; 
              font-size: 10px; 
              font-weight: 600;
              text-transform: uppercase;
            ">
              View
            </a>
          </div>
        `).join('')}
      </div>
    ` : '';

    return mainSection + sideSection + bottomSection;
  }

  private static generateMinimalListLayout(products: any[], primaryColor: string, secondaryColor: string, ctaButtonText: string): string {
    const productList = products.map((product, index) => `
      <div style="
        background-color: #ffffff;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        padding: 20px 24px;
        display: table;
        width: 100%;
        transition: all 0.2s ease;
        ${index === products.length - 1 ? 'border-bottom: none;' : ''}
      ">
        <div style="display: table-cell; width: 80px; vertical-align: middle; padding-right: 20px;">
          ${product.thumbnailPath ? `
            <img src="${product.thumbnailPath}" alt="${product.productName}" 
                 style="
                   width: 60px; 
                   height: 60px; 
                   object-fit: cover; 
                   border-radius: 8px;
                   box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                 ">
          ` : `
            <div style="
              width: 60px; 
              height: 60px; 
              background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
              color: white; 
              border-radius: 8px;
              display: flex; 
              align-items: center; 
              justify-content: center; 
              font-size: 20px; 
              font-weight: 700;
              box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            ">
              ${product.productName.charAt(0)}
            </div>
          `}
        </div>
        <div style="display: table-cell; vertical-align: middle; padding-right: 20px;">
          <h4 style="
            margin: 0 0 4px 0; 
            color: rgba(0,0,0,0.87); 
            font-size: 16px; 
            font-weight: 600; 
            line-height: 1.2;
            letter-spacing: -0.2px;
          ">
            ${product.productName}
          </h4>
          ${product.productBrand ? `
            <p style="
              margin: 0 0 8px 0; 
              color: rgba(0,0,0,0.6); 
              font-size: 14px;
              font-weight: 400;
            ">
              ${product.productBrand}
            </p>
          ` : ''}
        </div>
        <div style="display: table-cell; vertical-align: middle; text-align: right; width: 140px;">
          <a href="${product.addToCartLink || product.link || '#'}" style="
            display: inline-block;
            background-color: ${primaryColor}; 
            color: white; 
            text-decoration: none; 
            padding: 10px 20px; 
            border-radius: 6px; 
            font-size: 13px; 
            font-weight: 500;
            text-transform: none;
            transition: all 0.2s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            letter-spacing: 0.3px;
          ">
            ${ctaButtonText}
          </a>
        </div>
      </div>
    `).join('');

    return `
      <div style="
        background-color: #ffffff; 
        border-radius: 8px; 
        overflow: hidden; 
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        border: 1px solid rgba(0,0,0,0.06);
        margin: 0 auto;
        max-width: 100%;
      ">
        ${productList}
      </div>
    `;
  }

  static generateVoucherHtml(
    voucherCode: string, 
    voucherValue: string, 
    expiryDate: string, 
    primaryColor: string = '#667eea', 
    secondaryColor: string = '#764ba2',
    voucherTitle: string = '🎉 Exclusive Voucher Code',
    voucherDescription: string = 'Save ${voucherValue}'
  ): string {
    return `
      <div style="margin: 40px 0; padding: 0 40px;">
        <div style="
          background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); 
          padding: 40px 30px; 
          text-align: center; 
          border-radius: 12px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.1);
        ">
          <h2 style="margin: 0 0 20px 0; color: white; font-size: 24px; font-weight: 700; letter-spacing: -0.5px;">
            <span 
              contenteditable="true" 
              data-field="voucherTitle"
              style="
                position: relative;
                display: inline-block;
                min-width: 20px;
                outline: none;
                border-radius: 4px;
                transition: all 0.2s ease;
                padding: 2px 4px;
                margin: -2px -4px;
              "
              onmouseover="this.style.backgroundColor='rgba(255, 255, 255, 0.1)'; this.style.boxShadow='0 0 0 2px rgba(255, 255, 255, 0.2)'"
              onmouseout="if(!this.matches(':focus')) { this.style.backgroundColor='transparent'; this.style.boxShadow='none' }"
              onfocus="
                this.style.backgroundColor='rgba(255, 255, 255, 0.15)'; 
                this.style.boxShadow='0 0 0 2px rgba(255, 255, 255, 0.4)';
                this.setAttribute('data-original', this.textContent);
              "
              onblur="
                this.style.backgroundColor='transparent'; 
                this.style.boxShadow='none';
                const newValue = this.textContent;
                const originalValue = this.getAttribute('data-original');
                if (newValue !== originalValue) {
                  window.parent.postMessage({
                    type: 'updateField', 
                    field: 'voucherTitle', 
                    value: newValue
                  }, '*');
                }
              "
              onkeydown="
                if (event.key === 'Enter' && !event.shiftKey) {
                  event.preventDefault();
                  this.blur();
                }
                if (event.key === 'Escape') {
                  this.textContent = this.getAttribute('data-original');
                  this.blur();
                }
              "
              title="Click to edit Voucher Title"
            >${voucherTitle}</span>
          </h2>
          <div style="
            background-color: white; 
            padding: 25px 20px; 
            border-radius: 8px; 
            margin: 20px 0;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          ">
            <div style="
              font-size: 32px; 
              font-weight: 700; 
              color: #1a1a1a; 
              letter-spacing: 3px; 
              margin-bottom: 8px;
              font-family: 'Courier New', monospace;
            ">
              ${voucherCode}
            </div>
            <div style="font-size: 16px; color: ${primaryColor}; font-weight: 600;">
              <span 
                contenteditable="true" 
                data-field="voucherDescription"
                style="
                  position: relative;
                  display: inline-block;
                  min-width: 20px;
                  outline: none;
                  border-radius: 4px;
                  transition: all 0.2s ease;
                  padding: 2px 4px;
                  margin: -2px -4px;
                "
                onmouseover="this.style.backgroundColor='rgba(102, 126, 234, 0.1)'; this.style.boxShadow='0 0 0 2px rgba(102, 126, 234, 0.2)'"
                onmouseout="if(!this.matches(':focus')) { this.style.backgroundColor='transparent'; this.style.boxShadow='none' }"
                onfocus="
                  this.style.backgroundColor='rgba(102, 126, 234, 0.15)'; 
                  this.style.boxShadow='0 0 0 2px rgba(102, 126, 234, 0.4)';
                  this.setAttribute('data-original', this.textContent);
                "
                onblur="
                  this.style.backgroundColor='transparent'; 
                  this.style.boxShadow='none';
                  const newValue = this.textContent;
                  const originalValue = this.getAttribute('data-original');
                  if (newValue !== originalValue) {
                    window.parent.postMessage({
                      type: 'updateField', 
                      field: 'voucherDescription', 
                      value: newValue
                    }, '*');
                  }
                "
                onkeydown="
                  if (event.key === 'Enter' && !event.shiftKey) {
                    event.preventDefault();
                    this.blur();
                  }
                  if (event.key === 'Escape') {
                    this.textContent = this.getAttribute('data-original');
                    this.blur();
                  }
                "
                title="Click to edit Voucher Description"
              >${voucherDescription}</span>
            </div>
          </div>
          <p style="margin: 0; color: rgba(255,255,255,0.9); font-size: 14px; font-weight: 500;">
            Valid until ${new Date(expiryDate).toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>
      </div>
    `;
  }

  static replaceTemplatePlaceholders(
    template: EmailTemplate, 
    customization: any, 
    products: any[] = [], 
    includeVoucher: boolean = false,
    productLayout: string = 'grid-cards'
  ): string {
    let html = template.htmlContent;
    
    // Replace basic placeholders
    html = html.replace(/\{\{COMPANY_NAME\}\}/g, customization.companyName || 'Your Company');
    
    // Replace company logo with proper HTML
    const logoHtml = customization.companyLogo 
      ? `<img src="${customization.companyLogo}" alt="${customization.companyName || 'Company'} Logo" style="max-height: 60px; max-width: 200px; height: auto; width: auto;" />`
      : `<div style="background-color: rgba(255,255,255,0.2); color: white; padding: 12px 24px; border-radius: 8px; font-size: 18px; font-weight: bold; display: inline-block;">${(customization.companyName || 'Your Company').charAt(0)}</div>`;
    html = html.replace(/\{\{COMPANY_LOGO\}\}/g, logoHtml);
    
    // Replace text content with editable spans
    const headerTitleHtml = `<span 
      contenteditable="true" 
      data-field="headerTitle"
      style="
        position: relative;
        display: inline-block;
        min-width: 20px;
        outline: none;
        border-radius: 4px;
        transition: all 0.2s ease;
        padding: 2px 4px;
        margin: -2px -4px;
      "
      onmouseover="this.style.backgroundColor='rgba(33, 150, 243, 0.1)'; this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.2)'"
      onmouseout="if(!this.matches(':focus')) { this.style.backgroundColor='transparent'; this.style.boxShadow='none' }"
      onfocus="
        this.style.backgroundColor='rgba(33, 150, 243, 0.15)'; 
        this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.4)';
        this.setAttribute('data-original', this.textContent);
      "
      onblur="
        this.style.backgroundColor='transparent'; 
        this.style.boxShadow='none';
        const newValue = this.textContent;
        const originalValue = this.getAttribute('data-original');
        if (newValue !== originalValue) {
          window.parent.postMessage({
            type: 'updateField', 
            field: 'headerTitle', 
            value: newValue
          }, '*');
        }
      "
      onkeydown="
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          this.blur();
        }
        if (event.key === 'Escape') {
          this.textContent = this.getAttribute('data-original');
          this.blur();
        }
      "
      title="Click to edit Header Title"
    >${customization.headerTitle || 'Exclusive Offers Just For You'}</span>`;
    
    const headerSubtitleHtml = `<span 
      contenteditable="true" 
      data-field="headerSubtitle"
      style="
        position: relative;
        display: inline-block;
        min-width: 20px;
        outline: none;
        border-radius: 4px;
        transition: all 0.2s ease;
        padding: 2px 4px;
        margin: -2px -4px;
      "
      onmouseover="this.style.backgroundColor='rgba(33, 150, 243, 0.1)'; this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.2)'"
      onmouseout="if(!this.matches(':focus')) { this.style.backgroundColor='transparent'; this.style.boxShadow='none' }"
      onfocus="
        this.style.backgroundColor='rgba(33, 150, 243, 0.15)'; 
        this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.4)';
        this.setAttribute('data-original', this.textContent);
      "
      onblur="
        this.style.backgroundColor='transparent'; 
        this.style.boxShadow='none';
        const newValue = this.textContent;
        const originalValue = this.getAttribute('data-original');
        if (newValue !== originalValue) {
          window.parent.postMessage({
            type: 'updateField', 
            field: 'headerSubtitle', 
            value: newValue
          }, '*');
        }
      "
      onkeydown="
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          this.blur();
        }
        if (event.key === 'Escape') {
          this.textContent = this.getAttribute('data-original');
          this.blur();
        }
      "
      title="Click to edit Header Subtitle"
    >${customization.headerSubtitle || 'Personalized recommendations based on your activity'}</span>`;
    
    const welcomeMessageHtml = `<span 
      contenteditable="true" 
      data-field="welcomeMessage"
      style="
        position: relative;
        display: inline-block;
        min-width: 20px;
        outline: none;
        border-radius: 4px;
        transition: all 0.2s ease;
        padding: 4px 6px;
        margin: -4px -6px;
        white-space: pre-line;
      "
      onmouseover="this.style.backgroundColor='rgba(33, 150, 243, 0.1)'; this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.2)'"
      onmouseout="if(!this.matches(':focus')) { this.style.backgroundColor='transparent'; this.style.boxShadow='none' }"
      onfocus="
        this.style.backgroundColor='rgba(33, 150, 243, 0.15)'; 
        this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.4)';
        this.setAttribute('data-original', this.textContent);
      "
      onblur="
        this.style.backgroundColor='transparent'; 
        this.style.boxShadow='none';
        const newValue = this.textContent;
        const originalValue = this.getAttribute('data-original');
        if (newValue !== originalValue) {
          window.parent.postMessage({
            type: 'updateField', 
            field: 'welcomeMessage', 
            value: newValue
          }, '*');
        }
      "
      onkeydown="
        if (event.key === 'Escape') {
          this.textContent = this.getAttribute('data-original');
          this.blur();
        }
      "
      title="Click to edit Welcome Message (Shift+Enter for new lines)"
    >${customization.welcomeMessage || 'Hello! 👋\n\nWe\'ve curated these exclusive offers based on your recent activity. Don\'t miss out on these limited-time deals!'}</span>`;
    
    const productSectionTitleHtml = `<span 
      contenteditable="true" 
      data-field="productSectionTitle"
      style="
        position: relative;
        display: inline-block;
        min-width: 20px;
        outline: none;
        border-radius: 4px;
        transition: all 0.2s ease;
        padding: 2px 4px;
        margin: -2px -4px;
      "
      onmouseover="this.style.backgroundColor='rgba(33, 150, 243, 0.1)'; this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.2)'"
      onmouseout="if(!this.matches(':focus')) { this.style.backgroundColor='transparent'; this.style.boxShadow='none' }"
      onfocus="
        this.style.backgroundColor='rgba(33, 150, 243, 0.15)'; 
        this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.4)';
        this.setAttribute('data-original', this.textContent);
      "
      onblur="
        this.style.backgroundColor='transparent'; 
        this.style.boxShadow='none';
        const newValue = this.textContent;
        const originalValue = this.getAttribute('data-original');
        if (newValue !== originalValue) {
          window.parent.postMessage({
            type: 'updateField', 
            field: 'productSectionTitle', 
            value: newValue
          }, '*');
        }
      "
      onkeydown="
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          this.blur();
        }
        if (event.key === 'Escape') {
          this.textContent = this.getAttribute('data-original');
          this.blur();
        }
      "
      title="Click to edit Product Section Title"
    >${customization.productSectionTitle || 'Featured Products'}</span>`;
    
    const footerTextHtml = `<span 
      contenteditable="true" 
      data-field="footerText"
      style="
        position: relative;
        display: inline-block;
        min-width: 20px;
        outline: none;
        border-radius: 4px;
        transition: all 0.2s ease;
        padding: 2px 4px;
        margin: -2px -4px;
      "
      onmouseover="this.style.backgroundColor='rgba(33, 150, 243, 0.1)'; this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.2)'"
      onmouseout="if(!this.matches(':focus')) { this.style.backgroundColor='transparent'; this.style.boxShadow='none' }"
      onfocus="
        this.style.backgroundColor='rgba(33, 150, 243, 0.15)'; 
        this.style.boxShadow='0 0 0 2px rgba(33, 150, 243, 0.4)';
        this.setAttribute('data-original', this.textContent);
      "
      onblur="
        this.style.backgroundColor='transparent'; 
        this.style.boxShadow='none';
        const newValue = this.textContent;
        const originalValue = this.getAttribute('data-original');
        if (newValue !== originalValue) {
          window.parent.postMessage({
            type: 'updateField', 
            field: 'footerText', 
            value: newValue
          }, '*');
        }
      "
      onkeydown="
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          this.blur();
        }
        if (event.key === 'Escape') {
          this.textContent = this.getAttribute('data-original');
          this.blur();
        }
      "
      title="Click to edit Footer Text"
    >${customization.footerText || 'Thank you for being a valued customer!'}</span>`;
    
    html = html.replace(/\{\{HEADER_TITLE\}\}/g, headerTitleHtml);
    html = html.replace(/\{\{HEADER_SUBTITLE\}\}/g, headerSubtitleHtml);
    html = html.replace(/\{\{WELCOME_MESSAGE\}\}/g, welcomeMessageHtml);
    html = html.replace(/\{\{PRODUCT_SECTION_TITLE\}\}/g, productSectionTitleHtml);
    html = html.replace(/\{\{FOOTER_TEXT\}\}/g, footerTextHtml);
    html = html.replace(/\{\{COPYRIGHT_TEXT\}\}/g, customization.copyrightText || 'All rights reserved.');
    html = html.replace(/\{\{POWERED_BY_TEXT\}\}/g, customization.poweredByText || 'Powered by');
    html = html.replace(/\{\{POWERED_BY_ARDEALY_TEXT\}\}/g, customization.poweredByArdealyText || 'Powered by Ardealy');

    // Replace colors
    html = html.replace(/\{\{PRIMARY_COLOR\}\}/g, customization.primaryColor || '#667eea');
    html = html.replace(/\{\{SECONDARY_COLOR\}\}/g, customization.secondaryColor || '#764ba2');
    
    // Replace products with selected layout
    const productsHtml = products.length > 0 
      ? this.generateProductHtml(products, customization.primaryColor, customization.secondaryColor, customization.ctaButtonText, productLayout) 
      : '<p style="text-align: center; color: #6b7280;">No products selected</p>';
    html = html.replace(/\{\{PRODUCTS\}\}/g, productsHtml);
    
    // Replace voucher section
    const voucherHtml = includeVoucher && customization.voucherCode 
      ? this.generateVoucherHtml(
          customization.voucherCode, 
          customization.voucherValue || '10%', 
          customization.voucherExpiryDate || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), 
          customization.primaryColor, 
          customization.secondaryColor,
          customization.voucherTitle,
          customization.voucherDescription
        )
      : '';
    html = html.replace(/\{\{VOUCHER_SECTION\}\}/g, voucherHtml);
    
    return html;
  }
} 